export default "__VITE_ASSET__B04X3WPq__"